import { useState } from "react";
// models
import {
  initialValuesCronogramaActividadesModel,
  CronogramaActividadesModel,
} from "../../../../../models/JuradosModel/cronogramaactividadesjurados.model";
// api services
import apiConvocatorias from "../../../../../api/Convocatorias/api-convocatorias";
// redux
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/reducers";
import moment from "moment";
import { openNotification } from "../../../../../utils/saveFile";
import { useEncrypt } from "../../../../../hooks/useEncrypt";

export const useCronogramaActividades = () => {
  // state
  const [fechas, setFechas] = useState<CronogramaActividadesModel>(
    initialValuesCronogramaActividadesModel
  );

  // redux
  // const { idConvocatoria } = useSelector((state: RootState) => state.convocatoria);
  const { decrypt, encrypt } = useEncrypt();
  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));
  // const { editarConvocatoria } = useSelector((state: RootState) => state.edicion);

  const editar_convocatoria = decrypt(
    localStorage.getItem("editar_convocatoria")
  );
  let editarConvocatoria = false;
  if (editar_convocatoria !== null) {
    editarConvocatoria = Boolean(editar_convocatoria);
  }

  const cargarConvocatoria = async () => {
    try {
      let { data } = await apiConvocatorias.getConvocatoriaById(idConvocatoria);
      let infoupdate = { ...fechas };
      if (data.fechas === null) data.fechas = [];

      if (data.fechas.length > 0) {
        infoupdate = {
          ...infoupdate,
          fecha_apertura: data.fechas[0].valormin || "",
          fecha_cierre: data.fechas[1].valormin || "",
          fecha_informe: data.fechas[2].valormin || "",
        };
      }

      return setFechas(infoupdate);
    } catch (error) {
      return console.error(error);
    }
  };

  // functions
  const guardarycontinuar = async (cambiarPestaña: any, state: any) => {
    let apertura = new Date(
      moment(fechas.fecha_apertura).format("YYYY/MM/DD")
    ).getTime();
    let cierre = new Date(
      moment(fechas.fecha_cierre).format("YYYY/MM/DD")
    ).getTime();
    let informe = new Date(
      moment(fechas.fecha_informe).format("YYYY/MM/DD")
    ).getTime();

    if (apertura >= cierre) {
      return openNotification({
        titulo: "Error",
        descripcion: "La fecha de apertura debe ser menor que todas las fechas",
        placement: "bottomRight",
      });
    }
    if (cierre >= informe) {
      return openNotification({
        titulo: "Error",
        descripcion:
          "La fecha de cierre debe ser menor que la fecha de informe",
        placement: "bottomRight",
      });
    }

    let todasfechas = [];
    todasfechas.push({
      id: 1,
      id_convocatoria: idConvocatoria,
      clave: "Apertura",
      valormin: fechas.fecha_apertura,
      valormax: "",
    });
    todasfechas.push({
      id: 2,
      id_convocatoria: idConvocatoria,
      clave: "Cierre",
      valormin: fechas.fecha_cierre,
      valormax: "",
    });
    todasfechas.push({
      id: 3,
      id_convocatoria: idConvocatoria,
      clave: "Informe de evaluación para conformación de la base de jurados.",
      valormin: fechas.fecha_informe,
      valormax: "",
    });
    await apiConvocatorias.guardarFechas(idConvocatoria, todasfechas);
    localStorage.setItem("cambiarPestaña", encrypt("2"));
    return cambiarPestaña({ ...state, activeTab: "3" });
  };
  return {
    fechas,
    setFechas,
    guardarycontinuar,
    cargarConvocatoria,
  };
};
